import {
  OrderProps,
  SET_ORDERS,
  OrderActionTypes,
  GET_ORDERS,
  GET_COOKS,
  SET_COOKS,
  SET_RATINGS,
} from './types';

const initState: OrderProps = {
  orders: [],
  userinfo: {
    id: '',
    firstName: '',
    address: {
      city: '',
      note: '',
      street: '',
    },
    image: '',
    phone: '',
    type: '',
    location: {
      lat: 0,
      lng: 0,
    },
    description: '',
  },
  ratings: [],
};

export const orderReducer = (
  state = initState,
  action: OrderActionTypes
): OrderProps => {
  const { type, orders, userinfo, ratings } = action;
  switch (type) {
    case GET_ORDERS:
      return state;
    case GET_COOKS:
      return state;
    case SET_ORDERS:
      return { ...state, orders };
    case SET_COOKS:
      return { ...state, userinfo };
    case SET_RATINGS:
      return { ...state, ratings };
    default:
      return state;
  }
};
